import React, { useRef } from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import { useReactToPrint } from 'react-to-print';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import { DialogHeader, DialogHeading } from '../../../Episode.Styled';
import PageOneCalOMSDischarge from './PageOneCalOMSDischarge';
import PageTwoCalOMSDischarge from './PageTwoCalOMSDischarge';

const CalOMSDischarge = (props) => {
  const { open, setOpen } = props;

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog fullScreen open={open} onClose={setOpen}>
      <DialogHeader>
        <DialogHeading variant="h5"></DialogHeading>
        <Box>
          <Button variant="contained" onClick={() => handlePrint()}>
            Print
          </Button>
          <IconButton onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogHeader>
      <Grid container ref={componentRef}>
        <PageOneCalOMSDischarge />
        <PageTwoCalOMSDischarge />
      </Grid>
    </Dialog>
  );
};

export default CalOMSDischarge;
